import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { OrderLifetimeAction } from './orderLifetime.action';
import { orderLifetimeInitialState } from './orderLifetime.constant';

export const orderLifetimeReducer = reducerWithInitialState(orderLifetimeInitialState)
  .case(OrderLifetimeAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(OrderLifetimeAction.loadList.done, (state, payload) => {
    const dataRecord = Object.fromEntries(payload.result.data.map((orderLifetime) => [orderLifetime.orderLifetimeId, orderLifetime]));
    return {
      ...state,
      data: dataRecord,
      defaultData: payload.result.defaultData,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(OrderLifetimeAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(OrderLifetimeAction.destroy, () => ({
    ...orderLifetimeInitialState,
  }));
